'use strict';

angular.module('amexReconciliationApp')
  .factory('ModelFactory', function ModelFactory($rootScope) {

    var modelFactory = {
      create: function (modelName, attrs) {
        return new Model($rootScope, modelName, attrs);
      }
    };

    return modelFactory;

    function Model(scope, modelName, attrs) {
      var self = this;

      var context = {};

      _.forEach(attrs, function (attr) {
        assignGetterSetter(attr);
        assignSubscriber(attr);
      });

      function assignGetterSetter(attr) {
        self[attr] = function (newVal) {
          if (arguments.length && !_.isEqual(context[attr], newVal)) {
            context[attr] = newVal;

            scope.$broadcast(eventFor(attr), context[attr]);
          }

          return context[attr];
        };
      }

      function assignSubscriber(attr) {
        self[subscriberFor(attr)] = function ($scope, handler, shouldPrepend, skipInitialization) {
          var eventName = eventFor(attr);

          $scope.$on(eventName, function (event, newVal) {
            handler(newVal);
          });

          if(shouldPrepend) {
            var eventListeners = $scope.$$listeners[eventName];
            var currentListener = eventListeners[eventListeners.length - 1];
            eventListeners.splice(eventListeners.length - 1, 1);
            eventListeners.unshift(currentListener);
          }

          if (!skipInitialization && context[attr]) {
            handler(context[attr]);
          }
        };
      }

      function eventFor(attr) {
        return modelName + '_' + attr + '_changed';
      }

      function subscriberFor(attr) {
        return _.camelCase('on ' + attr + ' changed');
      }
    }
  });




//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/factories/ModelFactory.js
// module id = 548
// module chunks = 0